export const GET_ALL_STYLEGUIDES = 'GET_ALL_STYLEGUIDES'
export const UPLOAD_STYLEGUIDES = 'UPLOAD_STYLEGUIDES'
export const DELETE_STYLEGUIDES = 'DELETE_STYLEGUIDES'
